import { render, staticRenderFns } from "./AnteprimaComponent.vue?vue&type=template&id=270befa4&"
import script from "./AnteprimaComponent.vue?vue&type=script&lang=js&"
export * from "./AnteprimaComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnteprimaComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports